<template>
  <v-layout justify-center wrap>
    <product-item
      v-for="p in cProductList"
      :key="p.id"
      :product="p"
      :register="handleRegister"
      :img-width="cProductList.length > 1 ? '300px':'750px'"
      :img-height="cProductList.length > 1 ? '200px':'500px'"
    />
    <pwc-no-data v-if="cProductList.length === 0" />
  </v-layout>
</template>

<script>
import ProductItem from './ProductItem'
import { logic } from '../common/mixin/logic'
import PwcNoData from '../../NoData'

export default {
  components: {
    ProductItem,
    PwcNoData
  },
  mixins: [logic]
}
</script>
